<template>
  <div class="page-shell">
    <top-bar title="Configs"/>
    <loading fullscrean="true" v-if="load"/>
    <div v-show="!load">
      <div class="position-relative rounded-top">
        <div class="container page-content">
          <div class="card text-center mb-3">
            <div class="card-body">
              <div class="user">
                <i class="fa-solid fa-user"></i>
              </div>
              <div>
                <h6 class="font-weight-bold mb-0">{{ user.nome }}</h6>
                <div class="small">{{user.nome_fantasia}}</div>
              </div>
            </div>
          </div>

          <download-app class="mb-3"/>

          <div class="card mb-3">
            <div class="card-body">
              <h6 class="font-weight-bold">Alertas Sonoros</h6>
              <a href="javascript:" class="btn-list" @click.stop="toggleAlerta(true)">
                <div><i class="fa-solid fa-volume-low mr-1"></i>Ativado</div>
                <i :class="canPlay ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle'"></i>
              </a>
              <a href="javascript:" class="btn-list" @click.stop="toggleAlerta(false)">
                <div><i class="fa-solid fa-volume-xmark mr-1"></i>Desativado</div>
                <i :class="!canPlay ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle'"></i>
              </a>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <h6 class="font-weight-bold">Navegação</h6>
              <a href="javascript:" class="btn-list" @click="alterarNavegacao(1)">
                <div><i class="fa-brands fa-google mr-1"></i>Google Maps</div>
                <i :class="navegacao === 1 ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle'"></i>
              </a>
              <a href="javascript:" class="btn-list" @click="alterarNavegacao(2)">
                <div><i class="fa-brands fa-waze mr-1"></i>Waze</div>
                <i :class="navegacao === 2 ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle'"></i>
              </a>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <h6 class="font-weight-bold">Visual</h6>
              <a href="javascript:" class="btn-list" @click="alterarTema(1)">
                <div><i class="fa-solid fa-moon mr-1"></i>Modo Escuro</div>
                <i :class="theme === 1 ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle'"></i>
              </a>
              <a href="javascript:" class="btn-list" @click="alterarTema(2)">
                <div><i class="fa-solid fa-sun mr-1"></i>Modo Claro</div>
                <i :class="theme === 2 ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle'"></i>
              </a>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <h6 class="font-weight-bold">Rastreamento</h6>
              <router-link to="/logs" class="btn-list text-link">
                <div><i class="fa-solid fa-location-dot mr-1"></i>Status do rastreamento</div>
                <i class="fa-solid fa-angle-right"></i>
              </router-link>
            </div>
          </div>

          <div class="card mb-3" v-if="modoDev > 10">
            <div class="card-body">
              <h6 class="font-weight-bold">Desenvolvedor</h6>
              <a href="javascript:" class="btn-list" @click="toggleModoDev()">
                <div>Desativar modo desenvolvedor</div>
                <i class="fa-solid fa-toggle-off text-muted"/>
              </a>
              <a href="javascript:" class="btn-list" @click="toggleHomolog()">
                <div>Servidor de homologação</div>
                <i :class="isHomolog ? 'fa-solid fa-toggle-on text-primary' : 'fa-solid fa-toggle-off text-muted'"/>
              </a>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <h6 class="font-weight-bold">Aplicativo</h6>
              <router-link to="/sobre-app" class="btn-list text-link">
                <div><i class="fa-solid fa-heart mr-1"></i>Sobre o App</div>
                <i class="fa-solid fa-angle-right"></i>
              </router-link>
              <router-link to="/politica-de-privacidade" class="btn-list text-link">
                <div><i class="fa-solid fa-shield-halved mr-1"></i>Política de Privacidade</div>
                <i class="fa-solid fa-angle-right"></i>
              </router-link>
              <a href="javascript:" class="btn-list" @click="logout">
                <div><i class="fa-solid fa-right-to-bracket mr-1"></i>Sair</div>
                <i class="fa-solid fa-angle-right"></i>
              </a>
            </div>
          </div>

          <div class="text-center" @click.prevent="upModoDev()">Versão: {{version}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setNotificationMuted } from '@/services/notificationAudio';
import TopBar from "../components/TopBar";
import Icon from "../components/Icon";
import BottonBar from "@/components/BottonBar";
import DownloadApp from "@/components/DownloadApp";
import Loading from "@/components/Loading";
import { homologApiUrl } from "@/config/endpoints";
import { stopNativeTracking } from '@/services/nativeTracking';
import { clearPedidosCache } from '@/services/pedidosCache';
import { syncStatusBar } from '@/services/statusBar';
import { applyTheme } from '@/services/theme';

export default {
  name: 'Config',
  components: {Loading, DownloadApp, BottonBar, Icon, TopBar},
  data() {
    return {
      load: false,
      modoDev: 1
    }
  },

  methods: {
    logout() {
      this.$swal({
        text: "Deseja realmente sair do seu aplicativo?",
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true
      }).then((res => {
        if (res) {
          this.load = true;
          this.$store.commit('logout');
        }
      }));
    },

    alterarTema(tema) {
      this.$store.state.theme = tema;

      switch (tema) {
        case 1:
          localStorage.setItem('theme', tema);
          applyTheme(tema);
          break;

        case 2:
          localStorage.setItem('theme', tema);
          applyTheme(tema);
          break;

        default:
      }

      syncStatusBar(tema === 1);
    },

    alterarNavegacao(n) {
      localStorage.setItem('navegacao', n);
      this.$store.state.navegacao = n;
    },

    toggleAlerta(enabled) {
      return setNotificationMuted(!enabled);
    },

    upModoDev() {
      if (this.modoDev < 11) {
        this.modoDev++;

        if (this.modoDev > 10) {
          localStorage.setItem('modoDev', '1');
          this.$swal("Agora você é um desenvolvedor");
        }
      }
    },

    async toggleModoDev() {
      localStorage.removeItem('modoDev');
      localStorage.removeItem('base_server');
      await this.reiniciarSessao();
    },

    async toggleHomolog() {
      if (this.isHomolog) {
        localStorage.removeItem('base_server');

      } else {
        localStorage.setItem('base_server', homologApiUrl);
      }

      await this.reiniciarSessao();
    },

    async reiniciarSessao() {
      this.load = true;

      try {
        await stopNativeTracking();
      } catch (error) {
        console.log('stopNativeTracking', error);
      }

      localStorage.removeItem('geoLocation');
      localStorage.removeItem('key');
      localStorage.removeItem('x_auth');
      localStorage.removeItem('appData');
      localStorage.removeItem('pendingTrackingPosition');
      clearPedidosCache();
      sessionStorage.removeItem('lastPost');
      window.location.reload();
    }
  },

  computed: {
    user() {
      return this.$store.state.user
    },

    theme() {
      return this.$store.state.theme;
    },

    navegacao() {
      return this.$store.state.navegacao;
    },

    canPlay() {
      return !this.$store.state.soundMuted;
    }
  },

  mounted() {
    this.modoDev = localStorage.getItem('modoDev') ? 11 : 1;
  }
}
</script>
<style scoped>
.user {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  font-size: 1.7rem;
  background: #c7f47b;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  border: 1px solid rgba(199, 244, 123, 0.45);
}

.btn-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-default);
  padding: 16px 0;
  border-bottom: 1px solid var(--border-color);
}

.btn-list .fa {
  width: 20px;
  font-size: 1.1rem;
}

.btn-list:hover {
  text-decoration: none;
}

.btn-list:last-child {
  border-bottom: none;
  padding-bottom: 12px;
}

.page-shell {
  min-height: 100vh;
  min-height: 100dvh;
}
</style>
